var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubProcess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#858A93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EEF0F3",
    d: "M29.109 17.16l.646 2.18c.219.752.97 1.199 1.711 1.022l2.15-.511c1.052-.244 2.098.435 2.336 1.518a2.055 2.055 0 0 1-.475 1.812l-1.506 1.666a1.539 1.539 0 0 0 0 2.044l1.506 1.668a2.05 2.05 0 0 1-.1 2.84 1.917 1.917 0 0 1-1.761.49l-2.15-.512c-.74-.173-1.483.272-1.702 1.02l-.647 2.18c-.308 1.056-1.39 1.655-2.418 1.338a1.974 1.974 0 0 1-1.3-1.337l-.653-2.18c-.22-.75-.97-1.2-1.711-1.023l-2.15.512c-1.054.244-2.1-.435-2.337-1.52a2.049 2.049 0 0 1 .476-1.81l1.505-1.668c.519-.576.519-1.466 0-2.043l-1.505-1.667a2.05 2.05 0 0 1 .1-2.84 1.917 1.917 0 0 1 1.761-.49l2.15.511c.742.177 1.49-.27 1.711-1.021l.646-2.18c.31-1.056 1.392-1.656 2.417-1.336a1.965 1.965 0 0 1 1.3 1.337z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.25 24.026a2.303 2.303 0 1 1 0 4.606 2.303 2.303 0 0 1 0-4.606zM14.678 28.632H2.52c-.84 0-1.52-.695-1.52-1.555V5.317c0-.858.68-1.554 1.52-1.554h27.355c.84 0 1.52.696 1.52 1.554V15.42M8.368 1v7.368M24.026 1v7.368M1 12.053h30.395"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubProcess);
export default __webpack_public_path__ + "static/media/sub-process.ba916008.svg";
export { ForwardRef as ReactComponent };